import { render, staticRenderFns } from "./order-modal-edit-additional-property.vue?vue&type=template&id=6a28f150&scoped=true"
import script from "./order-modal-edit-additional-property.vue?vue&type=script&lang=js"
export * from "./order-modal-edit-additional-property.vue?vue&type=script&lang=js"
import style0 from "./order-modal-edit-additional-property.vue?vue&type=style&index=0&id=6a28f150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28f150",
  null
  
)

export default component.exports